export default __webpack_public_path__ + "static/media/verified-icon-battleship-grey.651f4816.svg";